import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error in app:", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            textAlign: "center",
            fontFamily: "Inter, sans-serif",
            padding: "2rem",
          }}
        >
          <h1>Something went wrong.</h1>
          <p>An unexpected error occurred while rendering this page.</p>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: "1rem",
              padding: "10px 20px",
              cursor: "pointer",
              border: "none",
              borderRadius: "4px",
              backgroundColor: "#3085d6",
              color: "white",
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
